import DownloadButton from '@/components/Elements/Button/DownloadButton'
import ViewFileButton from '@/components/Elements/Button/ViewFileButton'
import { Flex } from '@chakra-ui/react'
import moment from 'moment'
import { TooltipCell, NormalTextCellRenderer } from '@/components/Table/components/Cell/ToolTipCell'

const DateCell = ({ format = 'DD-MMM-YYYY', getValue }) => {
  const date = moment(getValue() ?? null)

  return <TooltipCell text={date.isValid() ? date.format(format) : '(-)'} />
}

export default DateCell
